import comp from "./AIPanelContent";
export default comp;
